export const getErrString = (err: any) => {
  let errorMsg = 'Request failed.';
  if (err?.data) {
    errorMsg = err.data.message || '';

    // eslint-disable-next-line array-callback-return
    err.data.details?.map((e: any, index: number) => {
      const detailErrorMsg = `${e.path}(${e.value}) is ${e.msg?.toLowerCase()}`;
      if (index === 0) errorMsg = detailErrorMsg;
      else errorMsg = errorMsg + `, ${detailErrorMsg}`;
    });
  }
  return errorMsg;
};
